@for (listing of listings(); track listing.address) {
<div class="row">
  <app-pixel-creature class="avatar" [addr]="listing.address"></app-pixel-creature>

  <span class="pname" [class.hex]="!listing.username" [style.color]="listing.address | addressColor">
    <app-identity
      [username]="listing.username"
      [twitterHandle]="listing.twitterHandle"
      [fallback]="shortHex(listing.address)"
    ></app-identity>
  </span>

  <span class="copy">is looking for a match</span>
  <span class="fmt ui-label">{{ formatLabel(listing.battleMode) }}</span>

  <span class="spacer"></span>

  <span class="waited">{{ waited(listing.joinedAt) }}</span>
  <button class="join" [disabled]="!canJoin()" (click)="onJoin(listing.address, listing.battleMode)">
    Join
  </button>
</div>
}
